import { Component,Input, OnInit } from '@angular/core';
import { ReplacePatientTermPipe, SanitizeHtmlPipe } from '../filter-section.pipe';
import { SharedDataService } from 'src/services/shared-data.service';
import { QuestionnaireResponseQuestion } from 'src/models/questionnaire-response.model';

@Component({
    selector: 'app-question-no-answer',
    templateUrl: './question-no-answer.component.html',
    styleUrls: ['./question-no-answer.component.css'],
    standalone: true,
    imports: [ReplacePatientTermPipe, SanitizeHtmlPipe]
})
export class QuestionNoAnswerComponent implements OnInit {

  @Input() question!: QuestionnaireResponseQuestion;
  patientTerm!: string;

  constructor(private _sharedDataService: SharedDataService){}

  ngOnInit(): void {
    this._sharedDataService.patientTerm$.subscribe((patientTerm) => {
      this.patientTerm = patientTerm
    })
  }

}
